import { defineMessages } from 'utils/intl';

export default defineMessages({
  resultsPerPage: 'Wyników na stronie',
});
